/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../../../../_metronic/_helpers";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { openStudentAbsenteeismsPage, date }
) => (
  <OverlayTrigger
    overlay={<Tooltip id="student-absenteeisms-tooltip">Öğrenci Devamsızlıkları</Tooltip>}
  >
    <a
      className="btn btn-icon btn-light btn-hover-primary btn-sm"
      onClick={() => openStudentAbsenteeismsPage(row.id, date)}
    >
      <span className="svg-icon svg-icon-md svg-icon-primary">
        <SVG src={toAbsoluteUrl("/media/svg/icons/Text/Article.svg")} />
      </span>
    </a>
  </OverlayTrigger>
);